import styled from 'styled-components';

import BaseCard from '@/v2/components/BaseCard/BaseCard';
import MediaQueryBreakpoints from '@/v2/constants/MediaQueryBreakpoints';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Container = styled(BaseCard)`
  gap: 16px;
  width: 100%;
  max-width: 640px;
  padding: 32px;
  border-radius: 16px;
  text-align: center;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const SecondaryAction = styled.div`
  margin-top: 24px;

  @media (${MediaQueryBreakpoints.isUltraWide}) {
    margin-top: 12px;
  }
`;
